import React from 'react';

import DeprecatedDropdown from '../../../../deprecated/DeprecatedDropdown/DeprecatedDropdown';
import DeprecatedDropdownItem from '../../../../deprecated/DeprecatedDropdown/DeprecatedDropdownItem/DeprecatedDropdownItem';
import Checkbox from '../../../Checkbox/Checkbox';

import toggleColumns from '../../helpers/columns/toggleColumns';

const SelectColumns = ({ columns, visibleColumns, updateVisibleColumns }) => {
  const renderItems = () => {
    return columns.map((column, index) => {
      const value = visibleColumns.includes(column.label);
      const onChange = () => updateVisibleColumns(toggleColumns(column, visibleColumns, value));
      return (
        <DeprecatedDropdownItem key={`select-column-dropdown-${index}`}>
          <Checkbox id={`select-column-checkbox-${index}`} value={value} label={column.label} onChange={onChange} />
        </DeprecatedDropdownItem>
      );
    });
  };

  return (
    <DeprecatedDropdown preventClose trigger="Columns" hasArrow>
      <DeprecatedDropdownItem isHeader>select column</DeprecatedDropdownItem>
      {renderItems()}
    </DeprecatedDropdown>
  );
};

export default SelectColumns;
